import { updateExoRemoteDomain } from 'projects/angular-clarity/src/app/stores/client/powershell/exo/remote-domain/actions';
import { RemoteDomain } from 'projects/angular-clarity/src/app/stores/client/powershell/exo/remote-domain/model';

export function Remediate(_tenant: string, data: Partial<RemoteDomain>, schema: any) {
    // Target the tenant's actual catch-all remote domain (its name can be changed from the
    // default 'Default', which otherwise causes a "Resource not found" error — OS-431).
    if (schema.properties.AutoForwardEnabled.const === false) {
        return updateExoRemoteDomain({ _tenant, data: { AutoForwardEnabled: false, Identity: data.Identity } });
    }

    if (schema.properties.AutoForwardEnabled.const === true) {
        return updateExoRemoteDomain({ _tenant, data: { AutoForwardEnabled: true, Identity: data.Identity } });
    }
}
